__turbopack_context__.v({
  "className": "dm_sans_33b1d1fc-module__WHG6nG__className",
  "variable": "dm_sans_33b1d1fc-module__WHG6nG__variable",
});
